/* eslint-disable react-hooks/purity */
import { useEffect, useState } from "react";

/** Returns Date.now() refreshed on interval, so components using it re-render smoothly. */
export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

/** Returns a human countdown like "01:23" or "0s" from an ISO date string. */
export function useCountdown(targetIso) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, []);
  if (!targetIso) return { label: "—", remaining: 0, urgent: false };
  const ms = new Date(targetIso).getTime() - now;
  const remaining = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(remaining / 60);
  const s = remaining % 60;
  const label = remaining > 0 ? `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}` : "TERMINÉ";
  return { label, remaining, urgent: remaining > 0 && remaining <= 10 };
}

export function ProgressBar({ startIso, endIso }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, []);
  if (!startIso || !endIso) return null;
  const s = new Date(startIso).getTime();
  const e = new Date(endIso).getTime();
  const pct = Math.min(100, Math.max(0, ((now - s) / (e - s)) * 100));
  return (
    <div className="h-[3px] bg-[#EAE4D9] border border-[#2B2B2B] mt-1" data-testid="action-progress">
      <div className="h-full bg-[#1A1A1A]" style={{ width: `${pct}%` }} />
    </div>
  );
}
